import styled from 'styled-components';

export const DropdownWrapper = styled.div`
  position: relative;
`;
